import React, { FC } from "react";
import type { PaymentChannelsTagsProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Tags } from "../tags";
import { CrossBorderPayments } from "./cross-border-payments";

export const PaymentChannelsTags: FC<PaymentChannelsTagsProps> = ({
  title,
  tags,
  description,
}) => {
  return (
    <section className="paymentChannelsTags">
      <div className="wrapper">
        <h2 className="paymentChannelsTags--title">{title}</h2>
      </div>
      <Tags tags={tags} className="paymentChannelsTags--tags" />
      {/* <div className="wrapper">
        <ContentManager
          content={description}
          className="paymentChannelsTags--description"
        />
      </div> */}
      <CrossBorderPayments content={description} />
    </section>
  );
};
